import * as LogRocket from "logrocket";

LogRocket.init('uiqtcg/fiscalpop-claroshop');
console.log('==LOG R INIT ==')